import intlTelInput from 'intl-tel-input';
import { lt } from "intl-tel-input/i18n";
import { en } from "intl-tel-input/i18n";

let lang = document.documentElement.getAttribute('lang');

$('[data-input-format="intl-tel"]').each(function (){

    let $hidden = $('<input type="hidden" name="'+$(this).attr('name')+'" />');
    $(this).after($hidden)
    $hidden.val(this.value)
    $(this).attr('name', null);

    console.log(this.dataset.onlyCountries)

    let instance = intlTelInput(this, {
        //nationalMode: true,
        separateDialCode: true,
        onlyCountries: this.dataset.onlyCountries ? this.dataset.onlyCountries.split(',') : [],
        excludeCountries: this.dataset.excludeCountries ? this.dataset.excludeCountries.split(',') : [],
        //hiddenInput: () => ({ phone: "full_phone", country: "country_code" }),
        loadUtils: () => import("intl-tel-input/utils"),
        i18n: lang === 'lt' ? lt : en
    });

    function onChange(){
        $hidden.val(instance.getNumber()).change()
    }

    let $countrySelect = $(this).closest('.form-group-wrapper').find('[data-depend-key="country"]');
    if($countrySelect.length){
        $countrySelect.on('change', function (){
            if(this.value){
                instance.setCountry(this.value)
            }
        })
        //instance.setCountry($countrySelect.val())

    }

    // Handle paste event handle full numbers
    this.addEventListener("paste", (e) => {
        const pastedText = (e.clipboardData || window.clipboardData).getData('text').trim();
        
        if(pastedText){
            e.preventDefault();
            
            let numberToSet = pastedText;
            
            // If it does not start with +, prepend the current country dial code
            if(!pastedText.startsWith('+')){
                const selectedCountryData = instance.getSelectedCountryData();
                if(selectedCountryData){
                    numberToSet = '+' + selectedCountryData.dialCode + pastedText;
                }
            }

            instance.setNumber(numberToSet);
            setTimeout(() => {
                onChange();
            }, 50);
        }
    });

    this.addEventListener("countrychange", () => {
        onChange()
    });
    this.addEventListener("change", () => {
        onChange()
    });
    this.addEventListener("keyup", () => {
        onChange()
    });

})